import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { JobSearchState } from '@store/search/job-search/job-search.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([JobSearchState])],
})
export class SearchStoreModule {}
